/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type settlingin_ParentSettlingInIndicatorValue = {
    /**
     * IndicatorID references an indicator definition
     */
    indicator_id: string;
    /**
     * Value is the assessment
     */
    value: settlingin_ParentSettlingInIndicatorValue.value;
};
export namespace settlingin_ParentSettlingInIndicatorValue {
    /**
     * Value is the assessment
     */
    export enum value {
        GOOD = 'good',
        NEUTRAL = 'neutral',
        BAD = 'bad',
    }
}

